import { useCallback } from "react";

import { Stack, StackState } from "types/generated";

import useHasStackWriteAccess from "./useHasStackWriteAccess";

// Check if the user can confirm the stack run having only a stack
const useCanConfirmStackRun = (): ((stack: Stack) => boolean) => {
  const hasStackWriteAccess = useHasStackWriteAccess();

  return useCallback(
    (stack: Stack) => {
      return stack.state === StackState.Unconfirmed && hasStackWriteAccess(stack);
    },
    [hasStackWriteAccess]
  );
};

export default useCanConfirmStackRun;
